import { Container } from '@/components';
import React from 'react';
import Upload from './Upload';
import ETATable from './ETATable';

const UploadETA = () => {
  return (
    <Container title={'Upload ETA'}>
      <div>
        <Upload />
      </div>
      <div className="mx-24">
        <ETATable />
      </div>
    </Container>
  );
};

export default UploadETA;
